import { CompanyAts } from "src/types";
import { get, del, post } from "../utils";
import {
  AtsApplicationPaginationParams,
  AtsJobPaginationParams,
  AtsPaginationResults
} from "./type";
import { AtsApplication, AtsJob } from "src/types/merge_ats";

export async function getAtsMagicLink(): Promise<string> {
  return (await get({ path: "outdefine_hire/company_ats", suffix: "magic-link" })).body.link;
}

export async function getCompanyAts(): Promise<CompanyAts> {
  return (await get({ path: "outdefine_hire/company_ats" })).body.ats;
}

export async function unlinkCompanyAts() {
  return (await del({ path: "outdefine_hire/company_ats", suffix: "delete" })).body;
}

export async function getCompanyAtsJobs(
  queryParams: AtsJobPaginationParams
): Promise<AtsPaginationResults<AtsJob>> {
  return (await get({ path: "outdefine_hire/company_ats", suffix: "jobs", queryParams })).body;
}

export async function getCompanyAtsJob(queryParams: AtsJobPaginationParams): Promise<AtsJob> {
  return (await getCompanyAtsJobs(queryParams)).data[0];
}

export async function getCompanyAtsApplications(
  queryParams: AtsApplicationPaginationParams
): Promise<AtsPaginationResults<AtsApplication>> {
  return (await get({ path: "outdefine_hire/company_ats", suffix: "applications", queryParams }))
    .body;
}

export async function syncJobApplications(job_id: number | string): Promise<{ added: number }> {
  return (
    await post({ path: "outdefine_hire/company_ats", suffix: "sync_candidates", body: { job_id } })
  ).body.application;
}
